import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { User } from '@/domain/entities/user/user'
import { UserRegistrationRequest } from '@/domain/entities/user/userCreateRequest'
import { AuthStateModuleName } from '@/store/modules/modules'

export class AuthStateViewModel {
  private store = useStore()

  user: ComputedRef<User> = computed(() => this.store.getters[`${AuthStateModuleName}/user`])
  isLogin: ComputedRef<boolean> = computed(() => this.store.getters[`${AuthStateModuleName}/isLogin`])
  isLoading: ComputedRef<boolean> = computed(() => this.store.getters[`${AuthStateModuleName}/isLoading`])
  error: ComputedRef<Error | null> = computed(() => this.store.getters[`${AuthStateModuleName}/error`])

  checkSession(): void {
    this.store.dispatch(`${AuthStateModuleName}/checkSession`)
  }

  login(id: string, password: string): Promise<boolean> {
    return this.store.dispatch(`${AuthStateModuleName}/login`, { id, password })
  }

  logout(): void {
    this.store.dispatch(`${AuthStateModuleName}/logout`)
  }

  async registerUser(user: UserRegistrationRequest): Promise<void> {
    await this.store.dispatch(`${AuthStateModuleName}/registerUser`, { user })
  }
}
